import React, { useEffect, useState } from 'react';
import { MessageSquare, Facebook, Youtube, Shield, FileText, HelpCircle } from 'lucide-react';
type Language = 'es' | 'en' | 'pt';
const translations = {
  es: {
    description: 'La experiencia definitiva de servidor privado de MU Online. Únete a miles de jugadores en batallas épicas, conquista el castillo y conviértete en una leyenda.',
    quickLinks: 'Enlaces Rápidos',
    home: 'Inicio',
    register: 'Registrarse',
    download: 'Descargar',
    rankings: 'Rankings',
    webMarket: 'Mercado Web',
    support: 'Soporte',
    termsOfService: 'Términos de Servicio',
    privacyPolicy: 'Política de Privacidad',
    supportCenter: 'Centro de Soporte',
    allRightsReserved: 'Todos los derechos reservados.',
    disclaimer: 'MU Online es una marca registrada de Webzen Inc. No estamos afiliados con Webzen.'
  },
  en: {
    description: 'The ultimate MU Online private server experience. Join thousands of players in epic battles, conquer the castle, and become a legend.',
    quickLinks: 'Quick Links',
    home: 'Home',
    register: 'Register',
    download: 'Download',
    rankings: 'Rankings',
    webMarket: 'Web Market',
    support: 'Support',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    supportCenter: 'Support Center',
    allRightsReserved: 'All rights reserved.',
    disclaimer: 'MU Online is a registered trademark of Webzen Inc. We are not affiliated with Webzen.'
  },
  pt: {
    description: 'A experiência definitiva de servidor privado de MU Online. Junte-se a milhares de jogadores em batalhas épicas, conquiste o castelo e torne-se uma lenda.',
    quickLinks: 'Links Rápidos',
    home: 'Início',
    register: 'Registrar',
    download: 'Baixar',
    rankings: 'Rankings',
    webMarket: 'Mercado Web',
    support: 'Suporte',
    termsOfService: 'Termos de Serviço',
    privacyPolicy: 'Política de Privacidade',
    supportCenter: 'Centro de Suporte',
    allRightsReserved: 'Todos os direitos reservados.',
    disclaimer: 'MU Online é uma marca registrada da Webzen Inc. Não somos afiliados à Webzen.'
  }
};
export function Footer() {
  const [language, setLanguage] = useState<Language>('es');
  const t = translations[language];
  useEffect(() => {
    const savedLang = localStorage.getItem('language') as Language;
    if (savedLang) setLanguage(savedLang);
    const handleLanguageChange = (e: CustomEvent<Language>) => {
      setLanguage(e.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => window.removeEventListener('languageChange', handleLanguageChange as EventListener);
  }, []);
  return <footer className="bg-[#03060a] border-t border-white/10 pt-16 pb-8 relative z-10" data-id="element-284">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-286">
          {/* Brand Col */}
          <div className="md:col-span-2" data-id="element-287">
            <a href="#home" className="flex items-center gap-3 mb-6" data-id="element-288">
              <img src="https://cdn.magicpatterns.com/uploads/npdMkBLoRCeQarTgcKB5ee/ChatGPT_Image_Mar_25,_2026,_10_14_36_AM.png" alt="MU Vanguard Logo" className="h-16 w-auto object-contain" data-id="element-289" />
              <div className="flex flex-col" data-id="element-290">
                <span className="font-cinzel font-bold text-2xl text-gradient-gold leading-none" data-id="element-291">
                  Vanguard
                </span>
                <span className="text-xs text-gray-400 tracking-widest uppercase mt-1" data-id="element-292">
                  Season 6
                </span>
              </div>
            </a>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-293">{t.description}</p>
            <div className="flex gap-4" data-id="element-294">
              <a href="#" data-testid="discord-widget-link" data-field="discord.widget" aria-label="Discord community" className="w-10 h-10 rounded-full bg-darkBlue border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#5865F2] hover:border-[#5865F2] transition-colors" data-id="element-295">
                <MessageSquare className="w-5 h-5" data-id="element-296" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-darkBlue border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#1877F2] hover:border-[#1877F2] transition-colors" data-id="element-297">
                <Facebook className="w-5 h-5" data-id="element-298" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-darkBlue border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#FF0000] hover:border-[#FF0000] transition-colors" data-id="element-299">
                <Youtube className="w-5 h-5" data-id="element-300" />
              </a>
            </div>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-301">
            <h4 className="font-cinzel font-bold text-white mb-6 text-lg" data-id="element-302">
              {t.quickLinks}
            </h4>
            <ul className="space-y-3" data-id="element-303">
              <li data-id="element-304">
                <a href="#home" className="text-gray-400 hover:text-gold transition-colors" data-id="element-305">
                  {t.home}
                </a>
              </li>
              <li data-id="element-306">
                <a href="#register" className="text-gray-400 hover:text-gold transition-colors" data-id="element-307">
                  {t.register}
                </a>
              </li>
              <li data-id="element-308">
                <a href="#download" className="text-gray-400 hover:text-gold transition-colors" data-id="element-309">
                  {t.download}
                </a>
              </li>
              <li data-id="element-310">
                <a href="#rankings" className="text-gray-400 hover:text-gold transition-colors" data-id="element-311">
                  {t.rankings}
                </a>
              </li>
              <li data-id="element-312">
                <a href="#market" className="text-gray-400 hover:text-gold transition-colors" data-id="element-313">
                  {t.webMarket}
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-314">
            <h4 className="font-cinzel font-bold text-white mb-6 text-lg" data-id="element-315">
              {t.support}
            </h4>
            <ul className="space-y-3" data-id="element-316">
              <li data-id="element-317">
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2" data-id="element-318">
                  <Shield className="w-4 h-4" data-id="element-319" /> {t.termsOfService}
                </a>
              </li>
              <li data-id="element-320">
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2" data-id="element-321">
                  <FileText className="w-4 h-4" data-id="element-322" /> {t.privacyPolicy}
                </a>
              </li>
              <li data-id="element-323">
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2" data-id="element-324">
                  <HelpCircle className="w-4 h-4" data-id="element-325" /> {t.supportCenter}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-326">
          <p className="text-sm text-gray-500" data-id="element-327">
            &copy; {new Date().getFullYear()} MU Vanguard. {t.allRightsReserved}
          </p>
          <p className="text-xs text-gray-600" data-id="element-328">{t.disclaimer}</p>
        </div>
      </div>
    </footer>;
}